import {
  IMPORT_STRUCTURES_20_FILE_UPLOAD,
  IMPORT_STRUCTURES_20_SUBMIT,
  IMPORT_STRUCTURES_20_REPORT_HIDE,
  IMPORT_STRUCTURES_FORM_CHANGE,
  IMPORT_STRUCTURES_20_RESET
} from "./actions";

import {REQUEST_SUCCESS, REQUEST_ERROR} from "../../../middlewares/api/actions";

const importStructures20Reducer = (
    state = {
        file: null,
        items: null,
        hash: null,
        report: null
    },
    action
) => {
    switch(action.type) {
        case IMPORT_STRUCTURES_FORM_CHANGE:
          return {
            ...state,
            file: action.fields.file !== undefined ? action.fields.file : state.file,
            items: null,
            hash: null
          };
        case IMPORT_STRUCTURES_20_REPORT_HIDE:
          return {
            ...state,
            report: null,
            items: null,
          };
        case IMPORT_STRUCTURES_20_RESET:
          return {
            ...state,
            file: null,
            items: null,
            hash: null,
            report: null
          };
        case REQUEST_SUCCESS:
            switch (action.label) {
                case IMPORT_STRUCTURES_20_FILE_UPLOAD:
                  return {
                    ...state,
                    hash: action.response.hashImport,
                    items: action.response.importedItem
                  };
                case IMPORT_STRUCTURES_20_SUBMIT:
                  return {
                    ...state,
                    file: null,
                    hash: null,
                    report: action.response.itemsMessage
                  };
                default:
                  return state;
              }
        case REQUEST_ERROR:
          return {
            ...state,
            file: null,
            hash: null,
            items: null,
            report: null
          }
        default:
          return state;
    }
};

export default importStructures20Reducer;
